import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { pinkPeople, pinkPeople50 } from '@/app/components/search/styles/colors.ts';
import { BaseBadgeContainer } from '../BaseBadge/styled';

const PinkPeopleStyled = styled(BaseBadgeContainer)`
  background-color: ${pinkPeople50};
  color: ${pinkPeople};
`;

const PinkPeopleBadge = () => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  return (
    <PinkPeopleStyled
      $icon={`${localization.imageBasePath}icons/pinkpeople.svg`}
      dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.pinkpeople_label_html') }}
    />
  );
};

export default PinkPeopleBadge;
